// extracted by mini-css-extract-plugin
export default {"card":"DashboardCard_card__ufyWD","delete":"DashboardCard_delete__4kt5I","handle":"DashboardCard_handle__tWDd0"};